export const validationLength = {
    extraSmall: 32,
    small: 64,
    medium: 128,
    large: 256,
    larger: 512,
    extraLarge: 1024,
};
